import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Cookie Policy</h1>
      <p>
        Utilizziamo i cookie per migliorare l'esperienza dell'utente sul nostro sito web. Questa informativa sui cookie spiega cosa sono i cookie, come li utilizziamo e come puoi gestirli.
      </p>
      <h2 className="text-xl font-bold mt-4">Cosa sono i cookie?</h2>
      <p>
        I cookie sono piccoli file di testo che vengono salvati sul tuo dispositivo quando visiti un sito web. Possono essere utilizzati per memorizzare le tue preferenze e altre informazioni.
      </p>
      <h2 className="text-xl font-bold mt-4">Come utilizziamo i cookie?</h2>
      <p>Utilizziamo i cookie per:</p>
      <ul className="list-disc list-inside">
        <li>Memorizzare le tue preferenze di navigazione</li>
        <li>Analizzare il traffico del sito web</li>
        <li>Personalizzare i contenuti offerti</li>
      </ul>
      <h2 className="text-xl font-bold mt-4">Come gestire i cookie?</h2>
      <p>
        Puoi gestire i cookie tramite le impostazioni del tuo browser. Tuttavia, disabilitare i cookie potrebbe influenzare la tua esperienza di navigazione sul nostro sito.
      </p>
      <h2 className="text-xl font-bold mt-4">Contatti</h2>
      <p>
        Per ulteriori informazioni sui cookie, contattaci contattaci su WhatsApp.
      </p>
    </div>
  );
};

export default CookiePolicy;
